// extracted by mini-css-extract-plugin
module.exports = {"Bio":"Bio_Bio__2q9Yh","Bio__Paragraph":"Bio_Bio__Paragraph__1KoJW","Bio__Closing":"Bio_Bio__Closing__lmfn1"};